export const initialState = {
  boolMap: {},
  psqlGroupnames: {},
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined
};

export default initialState;
